export default function($log, Swal) {
  'ngInject';

  $log.debug('Misc Files Comoponent Activated');

  const vm = this;

  vm.supported = false;

  vm.success = () => {
    Swal.toast('Copied');
  };

  vm.fail = error => {
    $log.error(error);
    throw error;
  };
}



// WEBPACK FOOTER //
// ./src/app/components/miscFiles/controller.js